import React from "react";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import styled from "styled-components";
import { SvgCloseLarge } from "../Svgs/CloseLarge";
import { Body1 } from "../Text";
import { colors } from "../Theme/colors";
import { Div } from "../utils";
const defaultDuration = 5000;
const defaultPosition = "bottom-left";
const toastBorderRadius = 6;
const Body1White = styled(Body1) `
  color: white;
`;
export const addToast = (msg, type = "blank", toastOptions = {}) => {
    const _toastOptions = Object.assign({ duration: defaultDuration, position: defaultPosition }, toastOptions);
    const toastFn = type === "blank" ? toast : toast[type];
    toastFn(msg, _toastOptions);
};
const toastContainerCss = {
    padding: 0,
    borderRadius: toastBorderRadius,
    boxShadow: "none",
};
const ToastWrapper = styled(Div) `
  padding: 10px;
  border-radius: ${toastBorderRadius}px;
  ${(p) => p.theme.css.alignCenter};
  ${(p) => {
    const c = p.theme.css;
    return [c.alignCenter];
}};
`;
const IconWrapper = styled(Div) `
  ${(p) => {
    const c = p.theme.css;
    return [c.alignCenter, c.clickable];
}};
  padding: 5px;
  color: ${(p) => p.theme.colors.white};
  margin-left: 10px;
  svg {
    path {
      fill: white;
    }
  }
`;
export const Toast = () => {
    return (React.createElement(Toaster, { toastOptions: {
            style: toastContainerCss,
        } }, (t) => (React.createElement(ToastBar, { toast: t }, ({ message }) => {
        return (React.createElement(ToastWrapper, { c: colors.white, bg: colors.black80 },
            React.createElement(Div, { alignCenter: true },
                React.createElement(Body1White, null, message)),
            React.createElement(IconWrapper, { onClick: () => toast.dismiss(t.id) },
                React.createElement(SvgCloseLarge, { height: 18 }))));
    }))));
};
//# sourceMappingURL=index.js.map